export class VestingTypeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTypes({ includeDeleted } = {}) {
    return this.#http.get('/vestingType', { params: { includeDeleted } });
  }

  async createType(body) {
    return this.#http.post('/vestingType', body);
  }

  async editType({ vestingTypeId, ...body }) {
    return this.#http.put(`/vestingType/${vestingTypeId}`, body);
  }

  async deleteType({ vestingTypeId }) {
    return this.#http.delete(`/vestingType/${vestingTypeId}`);
  }
}
